export default {
    messages: {
        _default: (field) => `El campo ${field} no es valido`,
        required: (field) => `El campo ${field} es requerido`
      },
      attributes: {
          payer: {
              full_name: 'Nombre completo',
              email: 'Correo electrónico',
              phone: 'Teléfono',
          },
          billing_address: {
              street1: 'Dirección',
              city: 'Ciudad',
              postal_code: 'Código postal',
              country: 'País',
          },
          credit_card: {
              number: 'Número',
              security_code: 'Código de seguridad',
              expiration_date: 'Fecha de expiración',
          },
      },
};
